import { H5Modal } from './H5Modal';
import { PCModal } from './PCModal';
import { LangContextProvider } from './LangContext';

export const Modal = ({ modalConfig, lanType }: { modalConfig: Record<string, any>; lanType: string }) => {
  return (
    <>
      <LangContextProvider lang={modalConfig} lanType={lanType}>
        <H5Modal />
        <PCModal />
      </LangContextProvider>
    </>
  );
};
